import { default as config } from "common/config/config";
import { useMemo } from "react";
import { useQueryClient } from "react-query";
import DataTable from "ui/common/components/display/DataTable/DataTable";
import useSearchParam from "ui/common/hooks/useSearchParam";
import useTableSearchParamPagination from "ui/common/hooks/useTableSearchParamPagination";
import useTableSearchParamSorting from "ui/common/hooks/useTableSearchParamSorting";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import RightToolbar from "./RightToolbar/RightToolbar";
import useFindReleaseStrategies from "features/release-strategy/hooks/useFindReleaseStrategies";
import { ADMIN_COLUMNS_KEYS, useAdminColumns } from "ui/admins/hooks/useAdminsColumns";

export default function AdminsTable() {
    const columns = useAdminColumns();
    const queryClient = useQueryClient();
    const [query] = useSearchParam("query");
    const [pagination, setPagination] = useTableSearchParamPagination();
    const [{ order, orderBy }, setSorting] = useTableSearchParamSorting(...ADMIN_COLUMNS_KEYS);

    const sortingState = useMemo(() => [{ id: orderBy, desc: order === "DESC" }], [orderBy, order]);

    const translate = useTranslate();

    const {
        data: { items = [], pages = 0, currentPage = 1, totalItems } = {},
        isLoading,
        isRefetching,
    } = useFindReleaseStrategies({
        query,
        page: pagination.pageIndex,
        order: order as "ASC" | "DESC",
        orderBy,
    });

    const handleRefresh = () => {
        queryClient.refetchQueries(Queries.RELEASE_STRATEGY_FIND_ALL);
    };

    return (
        <DataTable
            rightToolbar={<RightToolbar />}
            onRefresh={handleRefresh}
            isLoading={isLoading}
            refreshing={isRefetching}
            title={translate("administratorsAndSecurity")}
            pageSize={config.paginatedPageSizes.releaseStrategy}
            pageCount={pages}
            data={items}
            sorting={sortingState}
            columns={columns}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            manualSorting
            manualPagination
            pageIndex={currentPage - 1}
            rowCount={totalItems}
        />
    );
}
